import { useMarkingContext } from '../MarkingContext/MarkingContext';
import TableList from '../TableList/TableList';
import TableListLoading from './ListLoading';
import ListInfo from './ListInfo';

const List = () => {
  const { currentPeriodicalReport, markingStudents, loading } = useMarkingContext();
  
  if (loading || !currentPeriodicalReport?._id) {
    return (
      <TableListLoading currentPeriodicalReport={currentPeriodicalReport} />
    );
  }

  if (!currentPeriodicalReport?.isGeneratedMarking) {
    return (
      <ListInfo />
    );
  }
  return <TableList list={markingStudents} isLoading={loading} />;
};

export default List;
